import * as API from "@/services/API";
import { RecordIdentifier } from "@/data/global";

type ContactFormData = {
    regionId: RecordIdentifier,
    name: string,
    email: string,
    phone: string,
    text: string,
}

export default {
    getListForRegister() {
        return API.apiClient.get('/region?filter=register');
    },
    getList() {
        return API.apiClient.get('/region');
    },
    getRegion(regionId: number) {
        return API.apiClient.get(`/region/${regionId}`);
    },
    getRegionManager(regionId: number) {
        return API.apiClient.get(`/region/${regionId}?manager-only`);
    },
    getRegionCourses(regionId: number) {
        return API.apiClient.get(`/region/${regionId}/courses`);
    },
    getRegionProducts(regionId: number) {
        return API.apiClient.get(`/region/${regionId}/products`);
    },
    getRegionAppointments(regionId: number) {
        return API.apiClient.get(`/region/${regionId}/appointments`);
    },
    getRegionPaymentGateways(regionId: RecordIdentifier) {
        return API.apiClient.get(`/payment-gateways`, {params: {region: regionId}});
    },

    getRegionEnrollmentStatus(regionId: RecordIdentifier) {
        return API.apiClient.get(`/user/region/${regionId}/enrollment/status`);
    },
    enrollRegion(regionId: RecordIdentifier) {
        return API.apiClient.post(`/user/region/${regionId}/enrollment`);
    },
    withdrawRegion(regionId: RecordIdentifier) {
        return API.apiClient.delete(`/user/region/${regionId}/enrollment`);
    },

    submitContactForm(data: ContactFormData) {
        return API.apiClient.post(`/region/${data.regionId}/contact-form`, data);
    },
}
